export const explore = (userId:number, paginatedEndpoint:string|null) => {
    console.log("explore");
    return paginatedEndpoint || `api/client-request/${userId}`;
}

export const request = (userId:number, paginatedEndpoint:string|null) => 
    paginatedEndpoint || `api/client-user-request/${userId}`;

export const bookmarks = (userId:number, paginatedEndpoint:string|null) =>
    paginatedEndpoint || `api/bookmark/${userId}`

export const search = (userId:number, paginatedEndpoint:string|null, searchParams:any|null|undefined) =>
{
    console.log("search");
    console.log(searchParams);
    if (paginatedEndpoint) return paginatedEndpoint;    
    if(searchParams){
        if(searchParams.isGlobal){
            return `api/search-global/${userId}?query=${searchParams.query}`;
        }else{
            return `api/search/${userId}?query=${searchParams.query}`;
        }
    }
    return "";
}
    

export const getRequestEndpoint = (mode:string, userId:number, paginatedEnpoint:string|null, searchParams:any|null|undefined):string => {
    switch(mode){
        case "home": return request(userId, paginatedEnpoint);
        case "explore": return explore(userId, paginatedEnpoint);
        case "bookmarks": return bookmarks(userId, paginatedEnpoint);
        case "search": return search(userId, paginatedEnpoint, searchParams)
    }
    return "";
}
